/* eslint-disable import/prefer-default-export */
import {
  DigitalGroundTruth,
  GroundTruthMultiChoice,
  GroundTruthMultiChoiceWithText,
  GroundTruthNumberRange,
  GroundTruthRatio,
  GroundTruthSingleChoice,
  GroundTruthSingleChoiceWithText,
  GroundTruthString,
  QuestionTypeV2,
} from '../../redux/types';

const getHighestScoreSingleChoice = (
  gtSingleChoice: GroundTruthSingleChoice,
) => {
  const { payload } = gtSingleChoice;
  return Math.max(...Object.values(payload));
};

const getHighestScoreMultiChoice = (
  gtMultiChoice: GroundTruthMultiChoice,
): number => {
  const { payload } = gtMultiChoice;
  const { strict, truths } = payload;
  if (strict) { return payload.score; }
  const scoreArr = Object.values(truths);
  const sum = scoreArr.reduce((a, b) => a + b, 0);
  return sum;
};

const getHighestScoreString = (gtString: GroundTruthString): number => {
  const { payload } = gtString;
  const maxScore = Math.max(...payload.map((p) => p.score));
  return maxScore;
};

const getHihgestScoreNumberRange = (gtNumberRange: GroundTruthNumberRange): number => {
  const { payload } = gtNumberRange;
  return Math.max(payload.correct.score, payload.acceptable.score);
};

const getHihgestScoreRatio = (gtRatio: GroundTruthRatio): number => {
  const { payload } = gtRatio;
  return payload.score;
};

const getHighestScoreSingleChoiceWithText = (
  gtSingleChoice: GroundTruthSingleChoiceWithText,
) => {
  const { payload } = gtSingleChoice;
  return Math.max(...Object.values(payload).map((o) => o.score));
};

const getHighestScoreMultiChoiceWithText = (
  gtMultiChoice: GroundTruthMultiChoiceWithText,
): number => {
  const { payload } = gtMultiChoice;
  const { strict, truths } = payload;
  if (strict) { return payload.score; }
  const scoreArr = Object.values(truths).map((t) => t.score);
  const sum = scoreArr.reduce((a, b) => a + b, 0);
  return sum;
};

export const getHighestGroundTruthScore = (gt: DigitalGroundTruth): number => {
  let score = 0;
  switch (gt.type) {
    case QuestionTypeV2.SingleChoice:
      score = getHighestScoreSingleChoice(gt);
      break;
    case QuestionTypeV2.MultiChoice:
      score = getHighestScoreMultiChoice(gt);
      break;
    case QuestionTypeV2.String:
      score = getHighestScoreString(gt);
      break;
    case QuestionTypeV2.NumberRange:
      score = getHihgestScoreNumberRange(gt);
      break;
    case QuestionTypeV2.Ratio:
      score = getHihgestScoreRatio(gt);
      break;
    case QuestionTypeV2.SingleChoiceWithText:
      score = getHighestScoreSingleChoiceWithText(gt);
      break;
    case QuestionTypeV2.MultiChoiceWithText:
      score = getHighestScoreMultiChoiceWithText(gt);
      break;
    default:
      break;
  }
  return score;
};

export const evaluateGroundTruthGroupScore = (gtList: DigitalGroundTruth[]) => {
  const accumulatedScore = gtList.reduce(
    (acc, curGt) => acc + getHighestGroundTruthScore(curGt), 0,
  );
  return accumulatedScore;
};
